import React, { useState } from 'react';
import { Box, Collapse, IconButton, Typography, Stack } from '@mui/material';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import type { ExecuteCheckpointDef } from '@/types/run-stage.types';
import { CheckpointList } from '../CheckpointList';

interface CheckpointGroupProps {
  checkpoint: ExecuteCheckpointDef;
  isReadOnly?: boolean;
}

export const CheckpointGroup: React.FC<CheckpointGroupProps> = ({
  checkpoint,
  isReadOnly,
}) => {
  const [expanded, setExpanded] = useState(true);
  const children = checkpoint.children ?? [];

  return (
    <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1, overflow: 'hidden' }}>
      <Stack
        direction="row"
        sx={{
          alignItems: 'center',
          px: 1.5,
          py: 0.75,
          backgroundColor: 'grey.50',
          cursor: 'pointer',
        }}
        onClick={() => setExpanded(!expanded)}
      >
        <Typography variant="body2" sx={{ fontWeight: 600, flex: 1 }}>
          {checkpoint.checkpointName}
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={{ mr: 1 }}>
          {children.length} item(s)
        </Typography>
        <IconButton size="small">
          {expanded ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
        </IconButton>
      </Stack>
      <Collapse in={expanded}>
        <Box sx={{ p: 1.5 }}>
          {children.length > 0 ? (
            <CheckpointList checkpoints={children} isReadOnly={isReadOnly} />
          ) : (
            <Typography variant="body2" color="text.secondary">
              No items in this group.
            </Typography>
          )}
        </Box>
      </Collapse>
    </Box>
  );
};
